import $ from "jquery";
import jsSHA from "jssha";
import "./3rd_party/jquery.autocomplete.js"
import {getApiToken} from "./get-api-token";
import getAutocompleteCss from "./autocomplete-css.js"
import getStandardCss from "./standard-css";

var shaObj = new jsSHA('SHA-256', 'TEXT');
shaObj.update(window.location.href + DOMAIN);
var url_hash = shaObj.getHash("HEX");

//console.log(process.env.NODE_ENV);

// *********************************
// *     Autocomplete Stichwort    *
// *********************************

var SEARCH_HANDLER = (function (module) {

    var isJSON = function (json_str) {
        try {
            JSON.parse(json_str);
            return true;
        } catch (e) {
            console.error(e)
            return false;
        }
    };

    var build_autocomplete = function (elem, endpoint, apiToken) {

        $(elem).autocomplete({
            noCache: true,
            serviceUrl: endpoint,
            headers: {
                'X-API-TOKEN': apiToken
            },
            deferRequestBy: 300,
            delay: 10,
            maxHeight: '500',
            showNoSuggestionNotice: true,
            noSuggestionNotice: 'Hebamme nicht gefunden',
            paramName: 'keyword',
            autoSelectFirst: true,
            transformResult: function (response) {
                if (response === 'false' || !isJSON(response)) {
                    return {suggestions: []};
                } else {
                    let object = JSON.parse(response);
                    return {suggestions: object.midwifes || []};
                }
            },
            formatResult: function (suggestion, currentValue) {
                var val = suggestion.value;

                var re = new RegExp('(' + currentValue + ')', 'gi');
                val = val.replace(re, '<strong>$1</strong>');

                if (typeof suggestion.active !== 'undefined' && suggestion.active != 1) {
                    val = '<span class="inactive" title="Es wurden keine Hebammen zu diesem Begriff gefunden">' + val + '</span>';
                }
                return val;
            }
        });
    };

    module.init = function (elem, endpoint, apiKey) {
        build_autocomplete(elem, endpoint, apiKey);
    };

    return module;
}(SEARCH_HANDLER || {}));

function updateSearchparams(field, value) {
    $('#searchparam' + url_hash).val(value);
    $('#searchparam' + url_hash).attr('name', 'searchdata[' + field + ']');
}

// *********************************
// *      Autocomplete Ort/PLZ     *
// *********************************

var SEARCH_GEO = (function (module) {

    var isJSON = function (json_str) {
        try {
            JSON.parse(json_str);
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    };

    var build_autocomplete = function (elem, endpoint, apiToken) {

        $(elem).bind('focus', function () {
            $(this).autocomplete("search");
        });

        $(elem).bind('keyup', function (e) {
            if (e.keyCode != 13) {
                $('#selectedLocation-' + url_hash).val('');
            }
        });

        $(elem).autocomplete({
            noCache: true,
            serviceUrl: endpoint,
            headers: {
                'X-API-TOKEN': apiToken
            },
            deferRequestBy: 300,
            delay: 10,
            maxHeight: '500',
            showNoSuggestionNotice: true,
            noSuggestionNotice: 'Ort nicht gefunden',
            paramName: 'keyword',
            autoSelectFirst: true,
            transformResult: function (response) {
                if (response === 'false' || !isJSON(response)) {
                    return {suggestions: []};
                } else {
                    var r = JSON.parse(response);
                    return {suggestions: r.locations};
                }
            },
            formatResult: function (suggestion, currentValue) {
                var val = suggestion.value;

                var re = new RegExp('(' + currentValue + ')', 'gi');
                val = val.replace(re, '<strong>$1</strong>');

                if (typeof suggestion.active !== 'undefined' && suggestion.active != 1) {
                    val = '<span class="inactive" title="Es wurden keine Orte zu diesem Begriff gefunden">' + val + '</span>';
                }
                return val;
            },
            onSelect: function (suggestion) {
                $('#selectedLocation-' + url_hash).val(suggestion.data.location);
            }
        });
    };

    module.init = function (elem, endpoint, apiKey) {
        build_autocomplete(elem, endpoint, apiKey);
    };

    return module;
}(SEARCH_GEO || {}));

$(document).ready(function () {

    if ($('#bkk-hebammenfinder-searchlet-init').length == 0) {
        console.error('ERROR: Configuration for searchlet is missed. Searchlet plugin could not initialized');
        return false;
    }

    try {
        var searchlet_config = JSON.parse($('#bkk-hebammenfinder-searchlet-init').html());
    } catch (e) {
        console.error('ERROR: ' + e.message);
    }

    var form_url = '/suche/suchergebnis.php';
    var rest_url = '/api/autocompletion/midwifes';
    var rest_geo_url = '/api/autocompletion/locations';

    form_url = 'https://' + DOMAIN + form_url;
    rest_url = 'https://' + DOMAIN + rest_url;
    rest_geo_url = 'https://' + DOMAIN + rest_geo_url;

    var standard_config = {
        apiKey: '',
        cssAutocompletion: true,
        cssStandard: true
    };

    var select_options = {
        '0': 'Ganzer Ort',
        '5': '5 km',
        '10': '10 km',
        '20': '20 km',
        '50': '50 km',
        '100': '100 km',
        '200': '200 km',
        'bundesweit': 'Bundesweit',
    };

    var root = $('<div>')
        .attr('id', 'bkk-hebammenfinder-searchlet')
        .addClass('bkk-searchlet');

    var form = $('<form>')
        .attr('method', 'get')
        .attr('target', '_blank')
        .attr('action', form_url);

    var input_searchparam = $('<input>')
        .attr('id', 'searchparam' + url_hash)
        .attr('type', 'hidden')
        .attr('name', '')
        .attr('value', '');

    var label_midwife_keyword = $('<label>')
        .attr('for', 'searchdata-keyword-' + url_hash)
        .text('Name der Hebamme:');
    var input_midwife_keyword = $('<input>')
        .attr('id', 'searchdata-keyword-' + url_hash)
        .attr('type', 'text')
        .attr('name', 'searchdata[keyword]')
        .attr('placeholder', 'Nach Hebamme suchen');

    var label_zip_city = $('<label>')
        .attr('for', 'searchdata-zip-' + url_hash)
        .text('Ort/PLZ:');
    var input_zip_city = $('<input>')
        .attr('id', 'searchdata-zip-' + url_hash)
        .attr('type', 'text')
        .attr('name', 'searchdata[zip]')
        .attr('placeholder', 'PLZ oder Ort');
    var input_location = $('<input>')
        .attr('id', 'selectedLocation-' + url_hash)
        .attr('type', 'hidden')
        .attr('name', 'searchdata[location]');

    var label_maxdistance = $('<label>')
        .attr('for', 'searchdata-maxdistance-' + url_hash)
        .text('Umkreis:');
    var select_maxdistance = $('<select>')
        .attr('id', 'searchdata-maxdistance-' + url_hash)
        .attr('name', 'searchdata[maxDistance]');

    for (var key in select_options) {
        var option = $('<option>')
            .val(key)
            .text(select_options[key]);

        select_maxdistance.append(option);
    }

    var submit_button = $('<button>')
        .attr('id', 'search-btn-' + url_hash)
        .attr('type', 'submit')
        .html('Hebammen suchen');

    var div_elements = {};

    form.append(input_searchparam);

    // *********************************
    // *            Ort/PLZ            *
    // *********************************
    div_elements['row_zip_city'] = $('<div>')
        .addClass('bkk-searchlet-fieldset')
        .attr('id', 'bkk-searchlet-fieldset-zip-city');

    div_elements.row_zip_city.append(label_zip_city);
    div_elements.row_zip_city.append(input_zip_city);
    div_elements.row_zip_city.append(input_location);

    form.append(div_elements.row_zip_city);

    // *********************************
    // *            Umkreis            *
    // *********************************
    div_elements['row_maxdistance'] = $('<div>')
        .addClass('bkk-searchlet-fieldset')
        .attr('id', 'bkk-searchlet-fieldset-maxdistance');

    div_elements.row_maxdistance.append(label_maxdistance);
    div_elements.row_maxdistance.append(select_maxdistance);

    form.append(div_elements.row_maxdistance);

    // *********************************
    // *   Hebamme                     *
    // *********************************
    div_elements['row_midwife_keyword'] = $('<div>')
        .addClass('bkk-searchlet-fieldset')
        .attr('id', 'bkk-searchlet-fieldset-keyword');

    div_elements.row_midwife_keyword.append(label_midwife_keyword);
    div_elements.row_midwife_keyword.append(input_midwife_keyword);

    form.append(div_elements.row_midwife_keyword);

    // *********************************
    // *         Submit-Button         *
    // *********************************
    div_elements['row_submit_button'] = $('<div>')
        .addClass('bkk-searchlet-fieldset')
        .attr('id', 'bkk-searchlet-fieldset-submit');
    div_elements.row_submit_button.append($('<div>').addClass('bkk-searchlet-submit-button-placeholder'));
    div_elements.row_submit_button.append(submit_button);

    form.append(div_elements.row_submit_button);

    root.append(form);

    var cssStandard = typeof searchlet_config.cssStandard !== 'undefined' ? searchlet_config.cssStandard : standard_config.cssStandard;
    if (cssStandard == true) {
        var standardStyle = $('<style>').attr('type', 'text/css').html(getStandardCss());
        $('#bkk-hebammenfinder-searchlet-init').before(standardStyle);
    }

    var cssAutocompletion = typeof searchlet_config.cssAutocompletion !== 'undefined' ? searchlet_config.cssAutocompletion : standard_config.cssAutocompletion;
    if (cssAutocompletion == true) {
        var autocompleteStyle = $('<style>').attr('type', 'text/css').html(getAutocompleteCss());
        $('#bkk-hebammenfinder-searchlet-init').before(autocompleteStyle);
    }


    $('#bkk-hebammenfinder-searchlet-init').replaceWith(root);

    $('#searchdata-keyword-' + url_hash).keyup(function (e) {
        if (e.keyCode == 13) {
            $('#searchdata-zip-' + url_hash).focus();
            return false;
        }

        updateSearchparams('keyword', $(this).val());
    });

    var apiKey = typeof searchlet_config.apiKey !== 'undefined' ? searchlet_config.apiKey : standard_config.apiKey;

    getApiToken(apiKey, root, function(apiToken) {
        SEARCH_HANDLER.init($('#searchdata-keyword-' + url_hash), rest_url, apiToken);
        SEARCH_GEO.init($('#searchdata-zip-' + url_hash), rest_geo_url, apiToken);
    });
});
